var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBadgeAccountManager(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.3322C16 12.4056 15.984 12.4784 15.9518 12.5444C14.9731 14.5492 13.1189 16.0268 10.8609 16.6046L10.1299 16.8124C10.0448 16.8366 9.95486 16.8378 9.86919 16.8158L9.13913 16.629C6.88188 16.0274 5.02817 14.5502 4.0492 12.5697C4.0163 12.5031 4 12.4297 4 12.3554V5.59014C4 5.3183 4.21742 5.09763 4.48854 5.07793C6.38554 4.94008 8.18638 4.24756 9.67369 3.11021C9.86583 2.96328 10.1342 2.96331 10.3264 3.11003C11.8152 4.24599 13.6181 4.92154 15.517 5.07374C15.7859 5.09528 16 5.31507 16 5.58478V12.3322Z",
    fill: "#6467EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1922 6.13632L10.9987 8.56084C11.0257 8.64213 11.1032 8.69716 11.1907 8.69716H13.7976C13.9936 8.69716 14.0747 8.9423 13.9159 9.05437L11.8085 10.5413C11.7374 10.5914 11.7076 10.6807 11.7348 10.7622L12.5403 13.1796C12.6009 13.3614 12.3877 13.5127 12.2294 13.4002L10.1188 11.9001C10.048 11.8498 9.95213 11.8498 9.88131 11.9L7.77065 13.3968C7.61228 13.5091 7.39931 13.3578 7.45998 13.176L8.26535 10.763C8.29256 10.6815 8.26276 10.5921 8.19162 10.5419L6.08406 9.05435C5.92527 8.94226 6.00644 8.69716 6.20235 8.69716H8.80944C8.89694 8.69716 8.97449 8.64213 9.00152 8.56084L9.80801 6.13632C9.86847 5.95456 10.1317 5.95456 10.1922 6.13632Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeAccountManager);
export default __webpack_public_path__ + "static/media/badge-account-manager.84b7abb1.svg";
export { ForwardRef as ReactComponent };